var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "container" } }, [
    _c("div", { staticClass: "error-box" }, [
      _c("div", { staticClass: "error-in" }, [
        _c("div", { staticClass: "text-wrap" }, [
          _c("p", { staticClass: "tit" }, [
            _vm._v(_vm._s(_vm.$t(_vm.messageProperty)))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "txt" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("sdl.gcrm.common.apologize.info1")) +
                "\n          "
            ),
            _c("br"),
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("sdl.gcrm.common.apologize.info2")) +
                "\n          "
            ),
            _c("br"),
            _vm._v(" "),
            _vm.errorCode === "201"
              ? _c("span", [_vm._v("보안서약서 에러 발생.")])
              : _vm.errorCode === "404"
              ? _c("span", [
                  _vm._v(_vm._s(_vm.$t("sdl.gcrm.common.notFound.page")))
                ])
              : _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.errPack[_vm.errorCode]
                        ? _vm.$t(_vm.errPack[_vm.errorCode])
                        : ""
                    )
                  )
                ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn-wrap" }, [
          _vm.errorCode !== "410"
            ? _c("span", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-lg",
                    attrs: { type: "button" },
                    on: { click: _vm.goMain }
                  },
                  [_vm._v(_vm._s(_vm.$t("sdl.gcrm.common.go.main")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-lg",
                    attrs: { type: "button" },
                    on: { click: _vm.goBack }
                  },
                  [_vm._v(_vm._s(_vm.$t("sdl.gcrm.common.go.prev")))]
                )
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c0c86e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c0c86e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/EmptyPage.vue
// module id = null
// module chunks = 